import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotCompleteLoad = ({
    spotColor = "#8CE9D8",
    color = "#13126C",
    strokeWidth = "2.4",
    ...props
}: IconProps) => (
    <SVG viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_1304_7699)">
            <path
                d="M6.79968 24.8916C9.23264 17.7694 17.8816 11.1905 25.5222 8.65957C33.1971 6.11445 42.2925 8.15365 48.318 14.104C54.3436 20.0543 57.2813 28.9594 55.4676 36.4616C53.7043 43.9855 47.4083 48.5125 41.8663 51.2772C36.29 54.0561 31.4677 54.0662 25.7133 52.6734C19.9409 51.3306 14.0917 49.1155 11.0865 43.9083C8.08128 38.7012 4.33248 32.0279 6.79968 24.8916Z"
                fill={spotColor}
            />
            <path
                d="M38 7.07441C38.338 7.24168 38.6715 7.41689 39 7.59981M42 9.58751C42.1733 9.72263 42.3447 9.86014 42.5141 10M45 12.3799C45.1835 12.5834 45.3635 12.7901 45.5398 13M47.6816 16C47.7933 16.186 47.9026 16.3736 48.0092 16.5629C48.0908 16.7077 48.1709 16.8534 48.2494 17M49.9318 21C50.0355 21.3302 50.1321 21.6636 50.2214 22M50.9155 26C50.9715 26.659 51 27.3259 51 27.9994C51 40.886 40.5511 51.3327 27.6618 51.3327C16.6982 51.3327 5 40.89 5 27.9994C5 15.11 16.7031 4.66602 27.6618 4.66602C29.8587 4.66602 31.9846 4.96949 34 5.53678M22.3333 27.8333L27 32.5L36.3333 23.1667"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </SVG>
);
SpotCompleteLoad.displayName = "SpotCompleteLoad";
